import { TFunction } from "i18next";
import { number, object, string, ref } from "yup";

export const profileSchema = (t: TFunction) =>
  object({
    email: string()
      .email(t("profile.notValidEmail"))
      .max(180, t("profile.longEmail")),

    firstName: string()
      .max(255, t("profile.longFirstName"))
      .min(2, t("profile.shortFirstName"))
      .matches(/^[A-Za-zА-Яа-яЁё\s'-]+$/, t("profile.invalidFirstName")),

    lastName: string()
      .max(255, t("profile.longLastName"))
      .min(2, t("profile.shortLastName"))
      .matches(/^[A-Za-zА-Яа-яЁё\s'-]+$/, t("profile.invalidLastName")),

    phone: string()
      .required(t("profile.phoneRequired"))
      .min(10, t("profile.shortPhone"))
      .matches(/^\+?[1-9]\d{1,14}$/, t("profile.invalidPhone")),

    newPassword: string()
      .min(8, t("profile.shortPassword"))
      .max(255, t("profile.longPassword")),

    passwordConfirmed: string().oneOf(
      [ref("newPassword")],
      t("profile.passwordsMustMatch")
    ),

    countryId: number(),
  });
